module.exports = __webpack_public_path__ + "static/jigyo3-9b491a41e022dad3fd21e74fc97ee7ca.jpg";